import type { SxProps, Theme } from '@mui/material'

/**
 * Styles for NoData component matching Figma design specifications
 * Design reference: node 5781-11028
 */
export const styles: Record<string, SxProps<Theme>> = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1, // 8px
    paddingTop: 1, // 8px
    paddingBottom: 2, // 16px
    paddingX: 2, // 16px
    width: '100%',
    minHeight: '100%',
  },
}
